<template>
  <el-popover
      :value="visible"
      placement="bottom"
      title=""
      trigger="manual"
      width="450">
    <div class="panel">
      <div style="height: 10px;position: relative"><i class="iconfont icon-close" style="cursor:pointer;font-size:20px;position:absolute;top:-12px;right:-10px;" @click="close"></i></div>
      <div v-if="isCreating" style="display: flex;flex-direction: column;align-items: center;">
        <div v-loading="true" style="height: 60px;width: 60px"></div>
        <div class="tips">
          正在生成{{ typeDisplay }}，请耐心等待
        </div>
      </div>
      <div v-else>
        <div v-if="content.length === 0">
          <div style="padding-bottom:10px">
            <span style="font-weight: 400;color: #202223;font-size: 14px;">标题</span>
            <el-input v-model="title" class="inputTitle" :placeholder="`请先填入标题，再生成${typeDisplay}`"></el-input>
          </div>
          <div class="footer">
            <el-button :disabled="title.length ==0" :loading="isCreating" type="primary"
                       @click="createContent">生成{{ typeDisplay }}
            </el-button>

          </div>
        </div>
        <div v-else>
          <div class="content">{{ content }}</div>
          <div class="footer">
            <el-button @click="createContent">换一组</el-button>
            <el-button type="primary" @click="insert">插入并关闭</el-button>
            <el-button  @click="onCopy">复制</el-button>
          </div>
        </div>

      </div>
    </div>
    <el-button slot="reference" type="text" :disabled="isCreating" @click="btnClick" style="padding:0">
      <img src="https://img001.aivideo8.com/system/media/1678965626925.png" style="width: 18px;"/>
    小鱼AI
    </el-button>
  </el-popover>
</template>
<script>
import {copyValue} from '@/utils/util.js'

const typeObject = {
  title: 1,
  keyword: 2,
  desc: 3
}
export default {
  props: ['type', 'keywords','chatBtnStatus','accounts'],
  data() {
    return {
      title: '',
      isCreating: false,
      content: '',
      xhr: null,
      visible:false,
    }
  },
  methods: {
    insert(){
      console.log('插入')
      this.$emit('insert',this.content)
      this.visible = false
    },
    onCopy() {
      copyValue(this.content).then(() => {
        this.$message.success('复制成功')
        // this.$emit('update:visible', false)
        // this.visible = false
      })
    },
    otherVisible(){
      console.log(this.chatBtnStatus)
      let res = false
      for (const key in this.chatBtnStatus) {
        if (key == this.type) continue
        if (this.chatBtnStatus[key] == true)
          res = true
      }
      return res
    },
    btnClick() {
      if (this.isCreating || this.otherVisible()) return
      this.visible = !this.visible
    },
    close() {
      if (this.isCreating) return
      this.visible = false
    },
    createContent() {
      if (this.isCreating) return
      this.isCreating = true
      console.log('accounts', this.accounts)
      const mediaList = []
      this.accounts.forEach(account => {
        console.log('account', account)
        if (account.isChecked) {
          mediaList.push(account.media)
        }
      })
      console.log('mediaList',mediaList)
      const params = {
        title: this.title,
        type: typeObject[this.type],
        media: mediaList
      }
      this.xhr = $.ajax('/api/gpt/tdk', {
        method: 'POST',
        dataType: 'json',
        headers: {
          'Authorization': get_cookie_token(),
          'Content-Type': 'application/json',
        },
        timeout: 29 * 1000,
        // timeout: 1000,
        data: JSON.stringify(params)
      }).then((res) => {
        console.log('res', res)
        this.isCreating = false
        if (res.status != 1) {
          res.msg && this.$message.error(res.msg)
          return
        }
        this.content = res.data.content
      }).catch((e)=> {
        console.error(e)
        this.isCreating = false
        console.log(e.status)
        if (e.statusText == 'timeout') {
          this.$message.error('请求超时，请重试')
        }
      })
    },
    onClose() {
      this.title = ''
      this.content = ''
    },
    onShow() {
      this.title = this.keywords
    }
  },
  computed: {
    typeDisplay(){
      let text = ''
      switch (this.type) {
        case 'title':
          text = '标题';
          break;
        case 'keyword':
          text = '关键词';
          break;
        case 'desc':
          text = '描述';
          break;
      }
      return text
      // if (this.type === 'title') {}
    }
  },
  watch: {
    visible(val) {
      this.$emit('visibleChange', val)
      val ? this.onShow() : this.onClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.panel {
  padding: 12px;

  .inputTitle {
    width: calc(100% - 60px);
    margin-left: 10px;
  }

  .tips {
    font-weight: 400;
    color: #9A9A9A;
    font-size: 14px;
    margin-top: 15px;
  }

  .content {
    min-height: 20px;
    max-height: 100px;
    overflow: overlay !important;
    overflow: auto;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #202223;
  }

  .footer {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}
</style>